<template>
    <app-layout :showTrialPeriodBar="false">
        <common-content-spacer height="medium">
            <common-page-header :heading="pageTitle"></common-page-header>

            <common-page-plain>
                <common-content-wrapper width="small">
                    <accident-intake-wizard></accident-intake-wizard>
                </common-content-wrapper>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import AccidentIntakeWizard from 'components/forms/AccidentIntakeWizard'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            AppLayout,
            AccidentIntakeWizard,
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intake.heading')
            },
        },
    }
</script>
